import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { QRCodeModule } from 'angularx-qrcode';
import { AdminHeaderComponent } from './component/admin-header/admin-header.component';
import { MaterialModule } from './material.module';
import { HeaderPopoverMenuComponent } from './component/header-popover-menu/header-popover-menu.component';
import { SetupHeaderComponent } from './component/setup-header/setup-header.component';
import { InputFocus } from './input-focus.directive';
import { SetupFooterComponent } from './component/setup-footer/setup-footer.component';
import { PrizeCardComponent } from './component/prize-card/prize-card.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { MissingStepsPopoverComponent } from './component/missing-steps-popover/missing-steps-popover.component';
import { PhonePipe } from './phone.pipe';
import { CoreModule } from '../core/core.module';
import { SellerSelectComponent } from './component/seller-select/seller-select.component';
import { PrizeDetailCardComponent } from './component/prize-detail-card/prize-detail-card.component';
import { GuideCalloutComponent } from './component/guide-callout/guide-callout.component';


@NgModule({
  declarations: [
    InputFocus,
    PhonePipe,
    AdminHeaderComponent,
    HeaderPopoverMenuComponent,
    SetupHeaderComponent,
    SetupFooterComponent,
    PrizeCardComponent,
    MissingStepsPopoverComponent,
    SellerSelectComponent,
    PrizeDetailCardComponent,
    GuideCalloutComponent
  ],
  imports: [
    CoreModule,
    CommonModule,
    FormsModule,
    IonicModule,
    QRCodeModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    NgxPaginationModule,
  ],
  exports: [
    PhonePipe,
    InputFocus,
    CommonModule,
    FormsModule,
    IonicModule,
    QRCodeModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    AdminHeaderComponent,
    HeaderPopoverMenuComponent,
    SetupHeaderComponent,
    SetupFooterComponent,
    PrizeCardComponent,
    MissingStepsPopoverComponent,
    CoreModule,
    SellerSelectComponent,
    PrizeDetailCardComponent,
    GuideCalloutComponent
  ]
})
export class SharedModule { }
